interface IUsePasswordValidationProps {
  password?: string;
  confirmPassword?: string;
}

export const usePasswordValidation = ({ password = '', confirmPassword = '' }: IUsePasswordValidationProps) => {
  const validLength = password.length >= 8;
  const upperCase = password.toLowerCase() !== password;
  const lowerCase = password.toUpperCase() !== password;
  const hasNumber = /\d/.test(password);
  const match = !!password && password === confirmPassword;
  const isConfirmPasswordFilled = confirmPassword !== '';

  const isValidPassword = () => {
    return hasNumber && lowerCase && match && upperCase && validLength && isConfirmPasswordFilled;
  };

  return {
    validLength,
    hasNumber,
    upperCase,
    lowerCase,
    match,
    isConfirmPasswordFilled,
    isValidPassword
  };
};
